import { Wrapper } from '@cma/common'
import { Helmet } from 'react-helmet-async'

export default function Present() {
  return (
    <Wrapper>
      <Helmet>
        <title>Present - Cloud CMA</title>
      </Helmet>
      <h1>Present</h1>
    </Wrapper>
  )
}
